/**
 * The following scripts get applied on the frontend of your site.
 * 
 @see https://www.w3.org/WAI/ARIA/apg/patterns/tabs/examples/tabs-automatic/
 *
 */

jQuery(document).ready(function ($) {
    $('.tabs [role=tablist]').each(function () {
        var $tablist = $(this);
        var $tabs = $tablist.find('[role=tab]');
        var $tabpanels = $tabs.map(function () {
            return $('#' + $(this).attr('aria-controls'))[0];
        });

        var firstTab = $tabs.first();
        var lastTab = $tabs.last();

        function setSelectedTab($currentTab, setFocus = true) {
            $tabs.each(function (index) {
                var $tab = $(this);
                var $tabpanel = $($tabpanels[index]);
                if ($tab.is($currentTab)) {
                    $tab.attr('aria-selected', 'true').removeAttr('tabindex');
                    $tabpanel.removeClass('is-hidden');
                    if (setFocus) {
                        $tab.focus();
                    }
                } else {
                    $tab.attr('aria-selected', 'false').attr('tabindex', '-1');
                    $tabpanel.addClass('is-hidden');
                }
            });
        }

        function setSelectedToPreviousTab($currentTab) {
            if ($currentTab.is(firstTab)) {
                setSelectedTab(lastTab);
            } else {
                setSelectedTab($currentTab.prev('[role=tab]'));
            }
        }

        function setSelectedToNextTab($currentTab) {
            if ($currentTab.is(lastTab)) {
                setSelectedTab(firstTab);
            } else {
                setSelectedTab($currentTab.next('[role=tab]'));
            }
        }

        $tabs.attr({ 'tabindex': '-1', 'aria-selected': 'false' }).each(function () {
            var $tab = $(this);
            $tab.on('keydown', function (event) {
                var handled = false;
                switch (event.key) {
                    case 'ArrowLeft':
                        setSelectedToPreviousTab($tab);
                        handled = true;
                        break;
                    case 'ArrowRight':
                        setSelectedToNextTab($tab);
                        handled = true;
                        break;
                    case 'Home':
                        setSelectedTab(firstTab);
                        handled = true;
                        break;
                    case 'End':
                        setSelectedTab(lastTab);
                        handled = true;
                        break;
                }
                if (handled) {
                    event.preventDefault();
                }
            });
            $tab.on('click', function () {
                setSelectedTab($tab);
            });
        });

        setSelectedTab(firstTab, false);
    });

    // select tab with url hash
    if (window.location.hash) {
        const hash = window.location.hash;
        $(`button${hash}`).each(function () {
            $(this).get(0).scrollIntoView({ behavior: 'smooth' });
            $(this).trigger('click');
        })
    }
});
